// Persistent guest token (anti-duplicate vote/survey for unauthenticated users)
import { v4 as uuidv4 } from "uuid";

const KEY = "zev_guest_token";

export function getGuestToken() {
  let token = localStorage.getItem(KEY);
  if (!token) {
    token = uuidv4();
    localStorage.setItem(KEY, token);
  }
  return token;
}
